export default {
  legalTerms: 'https://influence.kolsquare.com/pages/en-cgu-0325/',
  privacyPolicy: 'https://influence.kolsquare.com/pages/en-privacy-0325',
};
